import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export const NotificationFlyer = () => {
  const [flyer, setFlyer] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.image) setFlyer(e.detail);
    };
    window.addEventListener('push-flyer', handler);
    return () => window.removeEventListener('push-flyer', handler);
  }, []);

  if (!flyer) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/85 flex items-center justify-center p-4"
      data-testid="notification-flyer-overlay"
      onClick={() => setFlyer(null)}
    >
      <div className="relative max-w-lg w-full" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={() => setFlyer(null)}
          className="absolute -top-3 -right-3 z-10 bg-white text-slate-800 rounded-full p-2 shadow-lg hover:bg-slate-100"
          data-testid="notification-flyer-close-btn"
          aria-label="Fechar"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="bg-white rounded-2xl overflow-hidden shadow-2xl">
          <img
            src={flyer.image}
            alt="Flyer"
            className="w-full max-h-[70vh] object-contain bg-slate-100"
            data-testid="notification-flyer-image"
          />
          {(flyer.title || flyer.body) && (
            <div className="p-4">
              {flyer.title && <h3 className="font-bold text-slate-900 text-base" data-testid="notification-flyer-title">{flyer.title}</h3>}
              {flyer.body && <p className="text-sm text-slate-600 mt-1" data-testid="notification-flyer-body">{flyer.body}</p>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationFlyer;
